/** mulberry32: tiny, fast, good enough for game rolls. Returns numbers in [0, 1). */
export function seededRng(seed) {
    let state = seed >>> 0;
    return () => {
        state = (state + 0x6d2b79f5) >>> 0;
        let t = state;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
export const systemRng = () => Math.random();
//# sourceMappingURL=random.js.map